var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"subtitle-1"},[_vm._v(_vm._s(_vm.$t('article.tabs.nutritions')))]),_c('VFormBuilder',{ref:"nutritions",attrs:{"items":_vm.nutritions,"initial-values":_vm.initValues ? _vm.initValues : {}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }